import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Phd_AdmissionELe from '../../IITTP/Admission/Phd_admissionEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission" />
            <Phd_AdmissionELe />
        </>
    )
}

export default Main